<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>

    <div class="md-layout-item">
      <ColapsibleList :list="list" ref="productsRef"></ColapsibleList>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import ColapsibleList from "@/components/DynamicForm/ColapsibleList";

  export default {
    components: {
      ColapsibleList
    },
    data() {
      return {
        list: {
          hideListHeader: true,
          editPath: "products",
          pageTitle: "Products",
          pageIcon: "devices",
          listQueryId: "searchProductsChildrens",
          responseFieldName: "searchProducts",
          linkRows: true,
          deleteQueryId: "deleteProduct",
          deleteRelatedRecord: {
            record: [ 
                { deleteSyncQueryId: "deleteCaseProduct", relatedModelItem: 'cases' } 
              ]
          },
          columns: {
            name: { label: "Model", sortable: true },
            productOptionName: { label: "Type" },
            status: { label: "Status", sortable: true },
            platform: { label: "Platform", sortable: true },
            terminalOrTsysId: { label: "Terminal ID/TSYS TID", sortable: true },
            midV: { label: "MID/V#", sortable: true },
            //billToServiceName: { label: "Bill To Service" },
            billingMethod: { label: "Billing Method", sortable: true },
            serial: { label: "Product Serial", sortable: true },
            createdAt: { label: "Created Date", sortable: true},
            replacementDate: { label: "Replacement Date", sortable: true}
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: data => {
            let result = [];
            if (data && typeof data.searchProducts !== 'undefined' && data.searchProducts.items && data.searchProducts.items.length) {
              let products = data.searchProducts.items;
              products.forEach((item) => {
                if (item) {
                  //set item's null value to blank
                  Object.keys(item).forEach((key) => {
                    if (item[key] === null) {
                      item[key] = '';
                    }
                  });

                  item.billToServiceName = (item.billToService && item.billToService.name)? item.billToService.name : '';
                  item.productOptionName = (item.productOption && item.productOption.name)? item.productOption.name : '';
                  //ATLAS-745 - Set flag for accordion display
                  item.isParentProduct = (item.children && item.children.items && item.children.items.length) ? true: false;
                  result.push(item);
                }
              })
            }

            const items = result;
            if (items && items.length) {
              const productsRef = this.$refs.productsRef;
              const sortedItmes = _.sortBy(items, productsRef.currentSort);
              if ('desc' == productsRef.currentSortDir) {
                result = sortedItmes.reverse();
              } else {
                result = sortedItmes;
              }
            }

            return result;
          },
        },
      };
    },
  };
</script>

<style></style>
